import initReactApp from 'dpl/util/initReactApp';
import UserAuthHeaderLink from 'dpl/UserAuth/components/UserAuthHeaderLink';
import UserAuthApp from 'dpl/auth/components/Routes/UserAuthV2';

initReactApp({
  UserAuthApp,
  UserAuthHeaderLink
});
